import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Container, Box, Grid, TextField, Select, MenuItem, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, FormHelperText } from '@material-ui/core';
import "./PreventiveMaintenance.css";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SelectAssetComponent from '../SelectAsset';
import { CreatePMPlan, getAllPM_plans } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const CreatePlan = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: ' Preventive Maintenance', href: '/preventive-maintenance' }
    ];
    const [show, setShow] = useState(true);
    const [showCreatePlan, setShowCreatePlan] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState(null);
    // const { response, loading } = useSelector((state) => state.pm);
    // const [searchInput, setSearchInput] = useState('');
    const [formData, setFormData] = useState({
        frequency: "",
        startDate: ""
    });
    const [open, setOpen] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    // const [loading, setLoading] = useState(true);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            { key: 'startDate', label: 'Start Date' },
            { key: 'frequency', label: 'Frequency' }
        ];

        requiredFields.forEach(({ key, label }) => {
            if (!formData[key]) {
                newErrors[key] = `${label} is required.`;
            }
        });

        setFormErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };

    const handleAssetSelection = (asset) => {
        console.log("check asset:", asset)
        setSelectedAsset(asset);
        setShow(false);
        setShowCreatePlan(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const CreatePlanHandler = async () => {

        if (!validateForm()) {
            toast.error("Please fill all required fields.");
            return; // Stop submission if validation fails
        }

        const selectedDate = new Date(formData.startDate);
        selectedDate.setHours(12, 0, 0, 0);

        // const formattedDate = selectedDate.toISOString().split('.')[0];

        // Format date as "DD/MM/YYYY HH:MM:SS"
        const formattedDate = `${String(selectedDate.getDate()).padStart(2, '0')}/${String(selectedDate.getMonth() + 1).padStart(2, '0')}/${selectedDate.getFullYear()} 00:00:00`;

        const newPlan = {
            asset_id: selectedAsset.Asset_id || selectedAsset.id,
            start_date: formattedDate,
            frequency: formData.frequency,
        };
        console.log("check payload:", newPlan)
        try {
            const action = dispatch(CreatePMPlan(newPlan));
            const res = await action.unwrap();
            if (res.StatusCode === 201) {
                const plan_id = res.result.pm_plan.id;
                toast.success("Plan created Sucessfully");
                navigate(`/add-plan/${plan_id}/${selectedAsset.Asset_no || selectedAsset.asset_no}`);
            }
        } catch (error) {
            toast.error(error.message || "Something went Wrong!");
        }
    };

    // const getAllplans = async () => {
    //     try {
    //         const action = dispatch(getAllPM_plans());
    //         const res = await action.unwrap();
    //         if (res.result) {
    //             // Extract `asset_no` from each `pm_plan` and store in an array
    //             const assetNumbers = res.result.pm_plan.map(plan => plan.assetMaster_details.asset_no);
    //             console.log(assetNumbers); // To verify the extracted `asset_no` values
    //         }

    //     } catch (error) {
    //         toast.error(error.message || "No Logs Found!");
    //     }
    // }

    // useEffect(() => {
    //     const fetchData = async () => {
    //         await getAllplans();
    //         setLoading(false);
    //     };
    //     fetchData();
    // }, [])

    // if (loading) {
    //     return (
    //         <Layout>
    //             <Container>
    //                 <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
    //                     <GridLoadingSpinner />
    //                 </Box>
    //             </Container>
    //         </Layout>
    //     );
    // }




    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Create Plan" />
                </Box>
                {show && <SelectAssetComponent handleAssetSelection={handleAssetSelection} title="Select Asset for Creating PM Plan" />}

                {showCreatePlan &&
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <h3>
                                Selected Asset: {selectedAsset.Asset_description || selectedAsset['Asset description']} ({selectedAsset.Asset_no || selectedAsset.asset_no})
                            </h3>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <FormControl variant="outlined" fullWidth error={!!formErrors.frequency} required>
                                <InputLabel>Frequency</InputLabel>
                                <Select
                                    value={formData.frequency}
                                    required
                                    onChange={handleInputChange}
                                    label="Frequency"
                                    name="frequency"
                                >
                                    <MenuItem value="weekly">Weekly</MenuItem>
                                    <MenuItem value="monthly">Monthly</MenuItem>
                                    <MenuItem value="quarterly">Quarterly</MenuItem>
                                    <MenuItem value="halfyearly">Half-Yearly</MenuItem>
                                    <MenuItem value="yearly">Yearly</MenuItem>
                                </Select>
                                {formErrors.frequency && (
                                    <FormHelperText>{formErrors.frequency}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                label="Start Date"
                                name="startDate"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                error={!!formErrors.startDate}
                                helperText={formErrors.startDate}
                                required
                                onChange={handleInputChange}
                            // inputProps={{
                            //     min: new Date().toISOString().split("T")[0],  // Set min attribute to today's date
                            //   }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Button
                                type="submit"
                                variant="contained"
                                style={{ backgroundColor: '#3f51b5', color: 'white' }}
                                onClick={() => CreatePlanHandler()}
                            >
                                Create PM Plan
                            </Button>
                        </Grid>
                    </Grid>}

                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Plan Already Exists"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" style={{ color: "red" }}>
                            A plan is already created for this asset. Please select a different asset.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default CreatePlan;
